/** URL prefixes of headerless SEO/lead landing pages (no site header, footer or splash). */
export const HEADLESS_LANDING_PREFIXES = ['/managed-it/', '/infor-support/', '/workday-support/', '/it-staffing/', '/ai-services/', '/software-development/'];

export const isHeadlessLanding = (pathname: string) => HEADLESS_LANDING_PREFIXES.some((p) => pathname.startsWith(p) && pathname.length > p.length);
